// extracted by mini-css-extract-plugin
export default {"img_ad_b":"index_img_ad_b_zEgi5"};